import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FadeTransform } from 'react-animation-components';
import { Control, Form } from 'react-redux-form';
import {
    Search, MapPin, Flag, ArrowRight, Calendar, Clock,
    PenSquare, Users, Package, Route,
    DollarSign, Zap, ShieldCheck, Leaf,
} from '../../icons';
import LocationSearchInput from '../common/LocationSearchCities';

const required = (val) => val && val.length > 2;

const DESTINATIONS = [
    { city: 'Paris',       country: 'France',   img: '/assets/images/top3/paris.jpg' },
    { city: 'Casablanca',  country: 'Maroc',    img: '/assets/images/top3/casablanca.jpeg' },
    { city: 'Bruxelles',   country: 'Belgique', img: '/assets/images/top3/bruxelles.jpg' },
];

const WHY_CARDS = [
    {
        Icon: DollarSign,
        color: '#e8f5e9', iconColor: '#2e7d32',
        title: "Jusqu'à 70 % moins cher",
        text: "Fini les tarifs exorbitants des transporteurs classiques. Nos voyageurs fixent leur propre prix — vous économisez sur chaque envoi, parfois plus de 80 €.",
    },
    {
        Icon: Zap,
        color: '#fff8e1', iconColor: '#f57f17',
        title: 'Livraison express',
        text: "Votre colis voyage directement avec une personne, sans entrepôt ni hub de tri. Paris-Casablanca en moins de 24 h, sans attente.",
    },
    {
        Icon: ShieldCheck,
        color: '#e3f2fd', iconColor: '#1565c0',
        title: 'Profils vérifiés',
        text: "Chaque membre est identifié par e-mail et téléphone. Lisez les avis, échangez en direct et choisissez le voyageur en toute confiance.",
    },
    {
        Icon: Leaf,
        color: '#f3e5f5', iconColor: '#6a1b9a',
        title: 'Éco-responsable',
        text: "Votre colis profite d'un trajet déjà prévu. Aucun véhicule supplémentaire, zéro émission inutile. L'envoi collaboratif, c'est aussi bon pour la planète.",
    },
];

const BLOG_ARTICLES = [
    {
        tag: 'Guide',
        img: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?auto=format&fit=crop&w=600&q=80',
        title: 'Comment envoyer un colis entre particuliers : le guide complet',
        excerpt: "Tout ce que vous devez savoir pour envoyer votre premier colis via un voyageur particulier.",
        date: '15 Mars 2024', readTime: '5 min',
    },
    {
        tag: 'Économies',
        img: 'https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=600&q=80',
        title: '5 raisons de choisir le transport entre particuliers plutôt que les services classiques',
        excerpt: "Prix, rapidité, flexibilité, personnalisation et écologie. Découvrez pourquoi des milliers d'expéditeurs font confiance aux voyageurs particuliers.",
        date: '28 Février 2024', readTime: '4 min',
    },
    {
        tag: 'Voyageurs',
        img: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=600&q=80',
        title: 'Voyageur : comment rentabiliser vos trajets en transportant des colis ?',
        excerpt: "Partir en voyage et gagner de l'argent en même temps, c'est possible !",
        date: '10 Février 2024', readTime: '6 min',
    },
];

const IC = { size: 16, strokeWidth: 2.5, style: { verticalAlign: 'middle' } };

function Home(props) {
    function handleSearchAnnouncements(values) {
        props.fetchAnnouncements(values.departure, values.destination, values.dateDeparture);
    }

    return (
        <div>

            {/* ── HERO ── */}
            <section className="hero-section">
                <div className="hero-overlay">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-9 text-center">
                                <p className="hero-badge">🌍 Transport de colis entre particuliers</p>
                                <h1 className="hero-title">
                                    Envoyez vos colis partout dans le monde,<br className="d-none d-md-block" /> simplement et économiquement
                                </h1>
                                <p className="hero-subtitle">
                                    Connectez-vous avec des voyageurs de confiance. Économisez jusqu'à 70&nbsp;% sur vos envois internationaux.
                                </p>
                                <div className="search-card">
                                    <Form validateOn="submit" model="searchTripsForm"
                                        onSubmit={(values) => handleSearchAnnouncements(values)}
                                        validators={{ departure: { required }, destination: { required } }}>
                                        <div className="row align-items-end">
                                            <div className="col-12 col-md-4 mb-3 mb-md-0">
                                                <label className="search-label">
                                                    <MapPin {...IC} color="var(--primary)" /> Départ
                                                </label>
                                                <LocationSearchInput model=".departure" id="departure" name="departure"
                                                    placeholder="Paris, Lyon, Rabat…" formName="searchTripsForm" />
                                            </div>
                                            <div className="col-12 col-md-4 mb-3 mb-md-0">
                                                <label className="search-label">
                                                    <Flag {...IC} color="var(--primary)" /> Destination
                                                </label>
                                                <LocationSearchInput model=".destination" id="destination" name="destination"
                                                    placeholder="Casablanca, Bruxelles…" formName="searchTripsForm" />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <Control.button className="btn btn-primary btn-search" model="searchTripsForm" type="submit">
                                                    {props.isSearchAnnouncements
                                                        ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                        : <><Search size={16} strokeWidth={2.5} />&nbsp; Rechercher</>
                                                    }
                                                </Control.button>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── STATS ── */}
            <section className="stats-section">
                <div className="container">
                    <div className="row text-center">
                        {[
                            { n: '10 000+', l: 'Utilisateurs actifs' },
                            { n: '50 000+', l: 'Colis livrés' },
                            { n: '30+',     l: 'Destinations' },
                            { n: '70%',     l: 'Économies moyennes' },
                        ].map((s, i) => (
                            <div key={i} className="col-6 col-md-3 stat-item">
                                <div className="stat-number">{s.n}</div>
                                <div className="stat-label">{s.l}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── COMMENT ÇA MARCHE ── */}
            <section className="section-padding bg-light-gray">
                <div className="container">
                    <div className="section-header text-center mb-5">
                        <span className="section-badge">Simple &amp; Rapide</span>
                        <h2 className="section-title">Comment ça marche ?</h2>
                        <p className="section-subtitle">En 3 étapes, trouvez un voyageur et envoyez votre colis n'importe où dans le monde.</p>
                    </div>
                    <div className="row justify-content-center">
                        {[
                            { Icon: PenSquare, title: 'Publiez votre annonce',    text: "Décrivez votre colis, indiquez votre destination et fixez votre prix. C'est gratuit et ne prend que 2 minutes." },
                            { Icon: Users,     title: 'Choisissez votre voyageur', text: 'Parcourez les profils de voyageurs vérifiés. Échangez directement via notre messagerie sécurisée.' },
                            { Icon: Package,   title: 'Votre colis est livré',     text: 'Remettez votre colis au voyageur. Livraison rapide, à prix réduit, en toute confiance.' },
                        ].map(({ Icon, title, text }, i) => (
                            <div key={i} className="col-12 col-md-4 step-item text-center">
                                <div className="step-icon-wrap">
                                    <Icon size={28} strokeWidth={1.8} color="var(--primary)" />
                                    <span className="step-number">{i + 1}</span>
                                </div>
                                <h4 className="step-title">{title}</h4>
                                <p className="step-desc">{text}</p>
                            </div>
                        ))}
                    </div>
                    <div className="text-center mt-4">
                        <Link to="/howitworks">
                            <Button color="primary" outline style={{ borderRadius: '50px', padding: '12px 28px', fontWeight: 700 }}>
                                En savoir plus &nbsp;<ArrowRight size={16} strokeWidth={2.5} style={{ verticalAlign: 'middle' }} />
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>

            {/* ── NOS SERVICES ── */}
            <section className="section-padding">
                <div className="container">
                    <div className="section-header text-center mb-5">
                        <span className="section-badge">Nos services</span>
                        <h2 className="section-title">Que souhaitez-vous faire ?</h2>
                        <p className="section-subtitle">Que vous soyez expéditeur ou voyageur, eudeliv a la solution qu'il vous faut.</p>
                    </div>
                    <div className="row">
                        {[
                            { img: '/assets/images/delivery.jpg', Icon: Package, title: 'Envoyer un colis', text: "Expédiez vos colis rapidement et à petit prix grâce à notre réseau de voyageurs de confiance. Documents, médicaments, alimentation… tout part en toute sécurité.", to: '/adddelivery', cta: "Publier une demande d'envoi" },
                            { img: '/assets/images/trip.jpg',     Icon: Route,   title: 'Transporter un colis', text: "Vous voyagez ? Rentabilisez votre trajet en transportant des colis. Gagnez de l'argent facilement tout en rendant service à notre communauté.", to: '/addtrip', cta: 'Proposer mon trajet' },
                        ].map(({ img, Icon, title, text, to, cta }, i) => (
                            <div key={i} className="col-12 col-md-6 mb-4">
                                <FadeTransform in transformProps={{ exitTransform: 'scale(0.5) translateY(-50%)' }}>
                                    <div className="service-card">
                                        <div className="service-card__img-wrap">
                                            <img src={img} alt={title} className="service-card__img" />
                                        </div>
                                        <div className="service-card__body">
                                            <Icon size={32} strokeWidth={1.6} className="service-card__icon" />
                                            <h3 className="service-card__title">{title}</h3>
                                            <p className="service-card__text">{text}</p>
                                            <Link to={to}>
                                                <Button color="primary" size="lg" className="service-card__btn">{cta}</Button>
                                            </Link>
                                        </div>
                                    </div>
                                </FadeTransform>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── TOP DESTINATIONS ── */}
            <section className="section-padding bg-light-gray">
                <div className="container">
                    <div className="section-header text-center mb-5">
                        <span className="section-badge">Populaires</span>
                        <h2 className="section-title">Top 3 des destinations</h2>
                        <p className="section-subtitle">Les routes les plus empruntées par notre communauté. Trouvez votre voyageur en quelques clics.</p>
                    </div>
                    <div className="row">
                        {DESTINATIONS.map((dest, i) => (
                            <div key={i} className="col-12 col-md-4 mb-4">
                                <FadeTransform in transformProps={{ exitTransform: 'scale(0.5) translateY(-50%)' }}>
                                    <Link to="/searchannouncements" className="destination-card-link">
                                        <div className="destination-card">
                                            <div className="destination-card__img-wrap">
                                                <img src={dest.img} alt={dest.city} className="destination-card__img" />
                                                <div className="destination-card__overlay">
                                                    <h4 className="destination-card__city">{dest.city}</h4>
                                                    <p className="destination-card__country">{dest.country}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </FadeTransform>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── POURQUOI EUDELIV ── */}
            <section className="section-padding">
                <div className="container">
                    <div className="section-header text-center mb-5">
                        <span className="section-badge">Nos avantages</span>
                        <h2 className="section-title">Pourquoi choisir eudeliv ?</h2>
                        <p className="section-subtitle">Plus économique, plus rapide et plus humain que n'importe quel transporteur classique.</p>
                    </div>
                    <div className="row">
                        {WHY_CARDS.map(({ Icon, color, iconColor, title, text }, i) => (
                            <div key={i} className="col-12 col-sm-6 col-lg-3 mb-4">
                                <FadeTransform in transformProps={{ exitTransform: 'scale(0.5) translateY(-50%)' }}>
                                    <div className="why-card">
                                        <div className="why-card__icon" style={{ background: color }}>
                                            <Icon size={24} strokeWidth={1.8} color={iconColor} />
                                        </div>
                                        <h4 className="why-card__title">{title}</h4>
                                        <p className="why-card__text">{text}</p>
                                    </div>
                                </FadeTransform>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── BLOG ── */}
            <section className="section-padding bg-light-gray">
                <div className="container">
                    <div className="section-header text-center mb-5">
                        <span className="section-badge">Blog</span>
                        <h2 className="section-title">Nos derniers articles</h2>
                        <p className="section-subtitle">Conseils pratiques, guides et actualités sur le transport de colis entre particuliers.</p>
                    </div>
                    <div className="row">
                        {BLOG_ARTICLES.map((article, i) => (
                            <div key={i} className="col-12 col-md-4 mb-4">
                                <FadeTransform in transformProps={{ exitTransform: 'scale(0.5) translateY(-50%)' }}>
                                    <Link to="/blog" className="blog-card-link">
                                        <div className="blog-card">
                                            <div className="blog-card__img-wrap">
                                                <img src={article.img} alt={article.title} className="blog-card__img" />
                                                <span className="blog-card__tag">{article.tag}</span>
                                            </div>
                                            <div className="blog-card__body">
                                                <div className="blog-card__meta">
                                                    <Calendar size={13} strokeWidth={2} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                                                    {article.date}
                                                    &nbsp;&nbsp;
                                                    <Clock size={13} strokeWidth={2} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                                                    {article.readTime} de lecture
                                                </div>
                                                <h4 className="blog-card__title">{article.title}</h4>
                                                <p className="blog-card__excerpt">{article.excerpt}</p>
                                                <span className="blog-card__more">
                                                    Lire l'article &nbsp;<ArrowRight size={14} strokeWidth={2.5} style={{ verticalAlign: 'middle' }} />
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                </FadeTransform>
                            </div>
                        ))}
                    </div>
                    <div className="text-center mt-2">
                        <Link to="/blog">
                            <Button color="primary" outline style={{ borderRadius: '50px', padding: '12px 28px', fontWeight: 700 }}>
                                Voir tous les articles &nbsp;<ArrowRight size={16} strokeWidth={2.5} style={{ verticalAlign: 'middle' }} />
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>

            {/* ── CTA ── */}
            <section className="cta-section">
                <div className="container">
                    <h2 className="cta-title">Prêt à envoyer votre premier colis ?</h2>
                    <p className="cta-subtitle">Rejoignez plus de 10 000 utilisateurs et économisez sur vos envois internationaux dès aujourd'hui.</p>
                    <div className="cta-buttons">
                        <Link to="/register">
                            <Button color="primary" size="lg" className="cta-btn">Créer un compte gratuit</Button>
                        </Link>
                        <Link to="/searchannouncements">
                            <Button outline color="light" size="lg" className="cta-btn">Voir les annonces</Button>
                        </Link>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Home;
